import styled, { css } from "styled-components";

import { AppType } from "../../types/global-type";

const AggregateMixin = css`
  & #calculationTargetId {
    width: 100%;
  }

  & #calculationType {
    position: static;
    padding-left: 0;
    width: 100%;
  }
`;

export const OuterContainer = styled.div`
  width: 320px;
`;

export const Container = styled.div<{ appType: AppType }>`
  width: 314px;
  padding-bottom: 64px;
  user-select: none;

  & #formTitleAxiosYOther {
    margin-top: 0;

    & > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      & > #calculationTargetId {
        width: calc(100% - 104px);
      }

      & > #calculationType {
        width: 96px;

        & .panda-input-dropdown--input {
          height: 32px;
        }
      }
    }
  }

  & #moreFold {
    margin-top: 18px;
  }

  & #filterFold {
    margin-top: 18px;
  }

  ${({ appType }) => appType === AppType.AGGREGATE && AggregateMixin};
`;

export const Title = styled.div``;

export const Panel = styled.div``;

export const Input = styled.input``;

export const Select = styled.select``;

export const ChildrenDiv = css`
  /* margin-bottom: 8px; */
`;
